    <section class="content-header ">
    
    <div class="row mb-2 ">
    <div class="col-sm-6">
    <h1>Factory Projection / Excel</h1>
    </div>
    
    
    </div>
    </section>
    
    <section class="content">
    
    <div class="card">
    <div class="card-header">
            <!-- <h3 class="subheading">Excel upload</h3> -->
            <div class="row">
              <div class="col-6">
                <input class="form-control w-25" type="month" name="current" [(ngModel)]="this.body.year_month">
              </div>
              <div class="col-6 d-flex justify-content-end">
                <button class="submit" (click)="submit()">submit</button>
              </div>
            </div>
    </div>
    <div class="card-body p-0 ml-5">
        <div class="container">
            <div class="row">
              <div class="col-sm">
                <input class="form-control w-25" type="file" (change)="onFileChange($event)" multiple="false" />
              </div>
            </div>
          </div>
          <div class="d-flex justify-content-center">
            <span *ngIf=loaderShown class="loader"></span>
          </div>
          <table class="table table-striped table-bordered mt-3" *ngIf="tableBol">
            <tr>
              <th>Material Name</th>
              <th>Uom</th>
              <th>In Liters</th>
              <th>Agreed Quantity</th>
              <th>Per Can Qty In Kg</th>
              <th>Intermediate</th>
              <th>Total Req Intermediate</th>
              <!-- <th>Portal Price</th> -->
            </tr>
            <tbody>
              <tr *ngFor="let x of factory_projection_array">
                <td>{{x.material_name}}</td>
                <td>{{x.uom}}</td>
                <td>{{x.in_liter}}</td>
                <td>{{x.approved_quantity}}</td>
                <td>{{x.per_can_qty_in_kg}}</td>
                <td>{{x.intermediate_material}}</td>
                <td>{{x.total_req_intermediate}}</td>
                <!-- <td>{{x.portal_price}}</td> -->
              </tr>
            </tbody>
          </table>
    </div>
    
    </div>
    
    </section>



    <!-- alert modal -->



    <div style="margin-top: 5rem; max-height: 500px;" class="modal fade" id="product-failed-modal" tabindex="-1" role="dialog"
  aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header d-flex justify-content-center">
        <h4 class="modal-title" id="exampleModalLabel">{{Failed_category.length}} Materials not Found</h4>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
       
        <p class="products" *ngFor="let items of Failed_category">
        {{items.material_name}}</p>

      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal"
          >Close</button>
        <!-- <button type="button" class="btn btn-primary"  data-dismiss="modal"></button> -->
      </div>
    </div>
  </div>
</div>
    <div style="margin-top: 5rem; max-height: 500px;" class="modal fade" id="inter-failed-modal" tabindex="-1" role="dialog"
  aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header d-flex justify-content-center">
        <h4 class="modal-title" id="exampleModalLabel">{{Failed_Intermediate.length}} Intermediates not Found</h4>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
       
        <p class="products" *ngFor="let items of Failed_Intermediate">
        {{items}}</p>

      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal"
          >Close</button>
        <!-- <button type="button" class="btn btn-primary"  data-dismiss="modal"></button> -->
      </div>
    </div>
  </div>
</div>